import {
  HStack,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";

export const EventsTag = ({
  isSelected,
  name,
  count,
  handlePress,
  size = "md",
}: {
  isSelected: boolean;
  name: string;
  count: number;
  handlePress: () => void;
  size?: "sm" | "md";
}) => {
  const fontSize = size === "sm" ? "mainTiny" : "mainSmall";
  const height = size === "sm" ? 16 : 32;

  return (
    <Pressable
      borderWidth={1}
      borderColor={isSelected ? "black" : "outline-default"}
      backgroundColor={isSelected ? "black" : "surface-primary"}
      height={height}
      borderRadius="2"
      alignItems="center"
      justifyContent="center"
      paddingHorizontal={3}
      onPress={handlePress}
      testID={`events-sidebar-tag-button-${name}`}
      accessibilityLabel={name}
      accessibilityState={{ selected: isSelected }}
    >
      <HStack gap={1} alignItems="center" justifyContent="center">
        <Text
          variant={fontSize}
          color={isSelected ? "text-inverse" : "text-primary"}
        >
          {name}
        </Text>
        <Text variant={fontSize} color="text-secondary">
          {count}
        </Text>
      </HStack>
    </Pressable>
  );
};
